import { useRedactionMode } from './useRedactionMode';
import { hasRedactedContent } from '../utils/contentTransform';

export const useDisplayContent = ({ mode, htmlContent, text, editable }) => {
  const { getCurrentDisplayContent } = useRedactionMode({ 
    mode, 
    htmlContent, 
    text, 
    editable 
  });

  const hasRedacted = hasRedactedContent(htmlContent || text);

  return {
    getCurrentDisplayContent,
    hasRedacted
  };
};
